var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-manager-element"
    },
    [
      _vm.currentElement
        ? _c(
            "div",
            [
              _vm.insertingInProgress
                ? _c("courseware-companion-box", {
                    attrs: {
                      msgCompanion: _vm.text.inProgress,
                      mood: "pointing"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.copyingFailed && !_vm.insertingInProgress
                ? _c("courseware-companion-box", {
                    attrs: {
                      msgCompanion: _vm.copyProcessFailedMessage,
                      mood: "sad"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cw-manager-element-title"
                },
                [
                  _c(
                    "nav",
                    {
                      staticClass: "cw-manager-element-breadcrumb",
                      attrs: {
                        "aria-label": "Breadcrumb"
                      }
                    },
                    _vm._l(_vm.breadcrumb, function(element) {
                      return _c(
                        "a",
                        {
                          key: element.id,
                          staticClass: "cw-manager-element-breadcrumb-item",
                          attrs: {
                            title: element.attributes.title,
                            href: "#"
                          },
                          on: {
                            click: function click($event) {
                              return _vm.selectChapter(element.id)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(element.attributes.title) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("header", [
                    _vm.elementInserterActive &&
                    _vm.moveSelfPossible &&
                    _vm.canEdit
                      ? _c(
                          "button",
                          {
                            staticClass: "cw-insert-element",
                            attrs: {
                              title: _vm.elementTitle
                            },
                            on: {
                              click: function click($event) {
                                return _vm.insertElement({
                                  element: _vm.currentElement,
                                  source: _vm.type
                                })
                              }
                            }
                          },
                          [
                            _c("studip-icon", {
                              attrs: {
                                shape: "arr_2left",
                                size: "24",
                                role: "clickable"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.elementName) +
                        "\n            "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              !_vm.elementsOnly
                ? _c(
                    "courseware-collapsible-box",
                    {
                      staticClass: "cw-manager-element-containers",
                      attrs: {
                        open: true,
                        title: _vm.$gettext("Abschnitt")
                      }
                    },
                    [
                      _vm.canSortContainers
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.sortContainersActive &&
                                      _vm.isCurrent,
                                    expression:
                                      "!sortContainersActive && isCurrent"
                                  }
                                ],
                                staticClass: "button sort",
                                on: {
                                  click: _vm.sortContainers
                                }
                              },
                              [
                                _c("translate", [
                                  _vm._v("Abschnitte sortieren")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.sortContainersActive && _vm.isCurrent,
                                    expression:
                                      "sortContainersActive && isCurrent"
                                  }
                                ],
                                staticClass: "button accept",
                                on: {
                                  click: _vm.storeContainersSort
                                }
                              },
                              [_c("translate", [_vm._v("Sortieren beenden")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.sortContainersActive && _vm.isCurrent,
                                    expression:
                                      "sortContainersActive && isCurrent"
                                  }
                                ],
                                staticClass: "button cancel",
                                on: {
                                  click: _vm.resetContainersSort
                                }
                              },
                              [
                                _c("translate", [_vm._v("Sortieren abbrechen")])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hasContainers
                        ? _c(
                            "p",
                            [
                              _c("translate", [
                                _vm._v(
                                  "Dieses Element enthält keine Abschnitte."
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "transition-group",
                        {
                          attrs: {
                            name: "cw-sort-ease",
                            tag: "div"
                          }
                        },
                        _vm._l(_vm.sortArrayContainers, function(
                          container,
                          index
                        ) {
                          return _c("courseware-manager-container", {
                            key: container.id,
                            attrs: {
                              container: container,
                              isCurrent: _vm.isCurrent,
                              sortContainers: _vm.sortContainersActive,
                              inserter:
                                _vm.containerInserterActive &&
                                _vm.moveSelfChildPossible,
                              elementType: _vm.type,
                              blockInserter: _vm.blockInserterActive,
                              canMoveUp: index !== 0,
                              canMoveDown:
                                index + 1 !== _vm.sortArrayContainers.length
                            },
                            on: {
                              insertContainer: _vm.insertContainer,
                              insertBlock: _vm.insertBlock,
                              moveUp: _vm.moveUpContainer,
                              moveDown: _vm.moveDownContainer
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.isCurrent && !_vm.sortContainersActive && _vm.canEdit
                        ? _c("courseware-manager-filing", {
                            attrs: {
                              parentId: _vm.currentElement.id,
                              parentItem: _vm.currentElement,
                              itemType: "container"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "courseware-collapsible-box",
                {
                  staticClass: "cw-manager-element-subchapters",
                  attrs: {
                    open: true,
                    title: _vm.$gettext("Unterseiten")
                  }
                },
                [
                  _vm.canSortChildren
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.sortChildrenActive && _vm.isCurrent,
                                expression: "!sortChildrenActive && isCurrent"
                              }
                            ],
                            staticClass: "button sort",
                            on: {
                              click: _vm.sortChildren
                            }
                          },
                          [_c("translate", [_vm._v("Unterseiten sortieren")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sortChildrenActive && _vm.isCurrent,
                                expression: "sortChildrenActive && isCurrent"
                              }
                            ],
                            staticClass: "button accept",
                            on: {
                              click: _vm.storeChildrenSort
                            }
                          },
                          [_c("translate", [_vm._v("Sortieren beenden")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sortChildrenActive && _vm.isCurrent,
                                expression: "sortChildrenActive && isCurrent"
                              }
                            ],
                            staticClass: "button cancel",
                            on: {
                              click: _vm.resetChildrenSort
                            }
                          },
                          [_c("translate", [_vm._v("Sortieren abbrechen")])],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hasChildren
                    ? _c(
                        "p",
                        [
                          _c("translate", [
                            _vm._v("Dieses Element enthält keine Unterseiten.")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "transition-group",
                    {
                      attrs: {
                        name: "cw-sort-ease",
                        tag: "div"
                      }
                    },
                    _vm._l(_vm.sortArrayChildren, function(child, index) {
                      return _c("courseware-manager-element-item", {
                        key: child.id,
                        attrs: {
                          element: child,
                          sortChapters: _vm.sortChildrenActive,
                          inserter:
                            _vm.elementInserterActive &&
                            _vm.moveSelfChildPossible &&
                            _vm.filingData.parentItem.id !== child.id,
                          type: _vm.type,
                          canMoveUp: index !== 0,
                          canMoveDown:
                            index + 1 !== _vm.sortArrayChildren.length
                        },
                        on: {
                          selectChapter: _vm.selectChapter,
                          insertElement: _vm.insertElement,
                          moveUp: _vm.moveUpChild,
                          moveDown: _vm.moveDownChild
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.isCurrent && !_vm.sortChildrenActive && _vm.canEdit
                    ? _c("courseware-manager-filing", {
                        attrs: {
                          parentId: _vm.currentElement.id,
                          parentItem: _vm.currentElement,
                          itemType: "element"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }